var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddReactionX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 11.4508 19.9448 10.9154 19.84 10.3989C19.7301 9.85768 20.0798 9.32985 20.621 9.21999C21.1623 9.11012 21.6901 9.45982 21.8 10.0011C21.9313 10.6478 22 11.3164 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.6321 2 13.2513 2.05877 13.8523 2.1714C14.3952 2.27314 14.7527 2.79567 14.651 3.3385C14.5493 3.88133 14.0268 4.23891 13.4839 4.13718C13.0038 4.0472 12.5079 4 12 4Z",
    className: "Icon-fill-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13C16.5523 13 17.0104 13.4522 16.9013 13.9936C16.4405 16.279 14.4212 18 12 18C9.57879 18 7.55953 16.279 7.09873 13.9936C6.98957 13.4522 7.44772 13 8 13H16Z",
    className: "Icon-fill-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1818 9.27271C10.1818 10.2769 9.36775 11.0909 8.36359 11.0909C7.35944 11.0909 6.54541 10.2769 6.54541 9.27271C6.54541 8.26856 7.35944 7.45453 8.36359 7.45453C9.36775 7.45453 10.1818 8.26856 10.1818 9.27271Z",
    className: "Icon-fill-color"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4547 9.27271C17.4547 10.2769 16.6407 11.0909 15.6365 11.0909C14.6324 11.0909 13.8184 10.2769 13.8184 9.27271C13.8184 8.26856 14.6324 7.45453 15.6365 7.45453C16.6407 7.45453 17.4547 8.26856 17.4547 9.27271Z",
    className: "Icon-fill-color"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 1C21 0.447715 20.5523 0 20 0C19.4477 0 19 0.447715 19 1V3H17C16.4477 3 16 3.44772 16 4C16 4.55228 16.4477 5 17 5H19V7C19 7.55229 19.4477 8 20 8C20.5523 8 21 7.55229 21 7V5H23C23.5523 5 24 4.55228 24 4C24 3.44772 23.5523 3 23 3H21V1Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddReactionX2);
export default __webpack_public_path__ + "static/media/AddReactionX2.e747b9966c7250efb11e59f1154a3bc2.svg";
export { ForwardRef as ReactComponent };